import { Directive, HostListener } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";

@Directive({
  selector: "[appTaxCertificateNumber]",
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: TaxCertificateNumberDirective,
      multi: true,
    },
  ],
})
export class TaxCertificateNumberDirective implements Validator {
  private readonly taxPattern: RegExp = /^\d{2}-\d{10}-\d{1}$/;

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const value2 = value
      .replace(/^(\d{2})(\d)/, "$1-$2") // Add the first dash after 2 digits
      .replace(/-(\d{10})(\d)/, "-$1-$2"); // Add the second dash after 10 digits
    if (!value) {
      return null; // Allow empty values for optional fields
    }

 const isValid =  this.taxPattern.test(value2);
    return this.taxPattern.test(value2) ? null : { invalidTaxCertificateNumber: true };
  }

  @HostListener("input", ["$event"])
  onInputChange(event: any): void {
    const input = event.target;
    let value = input.value.replace(/[^0-9\-]/g, ""); // Remove invalid characters
    value = value
      .replace(/^(\d{2})(\d)/, "$1-$2") // Add the first dash after 2 digits
      .replace(/-(\d{10})(\d)/, "-$1-$2"); // Add the second dash after 10 digits
    if (value.length > 15) {
      value = value.substring(0, 15); // Limit to the maximum length
    }
    input.value = value;
  }
}